function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Authors Copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Tabbar",
  transform: "translate(-322.000000, -12.000000)",
  fill: "#1E1F20"
}, React.createElement("g", {
  id: "Icons/Playlists"
}, React.createElement("g", {
  transform: "translate(318.000000, 8.000000)"
}, React.createElement("path", {
  d: "M4.95,4.7 L19.05,4.7 C19.5746705,4.7 20,5.12532949 20,5.65 C20,6.17467051 19.5746705,6.6 19.05,6.6 L4.95,6.6 C4.42532949,6.6 4,6.17467051 4,5.65 C4,5.12532949 4.42532949,4.7 4.95,4.7 Z M4.95,11 L19.05,11 C19.5746705,11 20,11.4253295 20,11.95 C20,12.4746705 19.5746705,12.9 19.05,12.9 L4.95,12.9 C4.42532949,12.9 4,12.4746705 4,11.95 C4,11.4253295 4.42532949,11 4.95,11 Z M4.95,17.3 L13.05,17.3 C13.5746705,17.3 14,17.7253295 14,18.25 C14,18.7746705 13.5746705,19.2 13.05,19.2 L4.95,19.2 C4.42532949,19.2 4,18.7746705 4,18.25 C4,17.7253295 4.42532949,17.3 4.95,17.3 Z",
  id: "Combined-Shape"
})))));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.6b0f033b.svg";
export { ForwardRef as ReactComponent };